import treo from 'treo'

// prettier-ignore
export default new treo.schema()
	.version(1)
		.addStore('courses', { key: 'clbid' })
			.addIndex('clbid', 'clbid', { unique: true })
			.addIndex('credits', 'credits')
			.addIndex('crsid', 'crsid')
			.addIndex('dept', 'dept')
			.addIndex('deptnum', 'deptnum')
			.addIndex('depts', 'depts', { multiEntry: true })
			.addIndex('desc', 'desc')
			.addIndex('gereqs', 'gereqs', { multiEntry: true })
			.addIndex('groupid', 'groupid')
			.addIndex('grouptype', 'grouptype')
			.addIndex('halfcredit', 'halfcredit')
			.addIndex('level', 'level')
			.addIndex('name', 'name')
			.addIndex('notes', 'notes')
			.addIndex('num', 'num')
			.addIndex('pf', 'pf')
			.addIndex('places', 'places', { multiEntry: true })
			.addIndex('profs', 'profs', { multiEntry: true })
			.addIndex('sect', 'sect')
			.addIndex('sem', 'sem')
			.addIndex('sourcePath', 'sourcePath')
			.addIndex('term', 'term')
			.addIndex('times', 'times', { multiEntry: true })
			.addIndex('title', 'title')
			.addIndex('type', 'type')
			.addIndex('year', 'year')
		.addStore('areas', { key: 'sourcePath' })
			.addIndex('sourcePath', 'sourcePath')
			.addIndex('type', 'type', { multiEntry: true })
		.addStore('students', { key: 'id' })
	.version(2)
		.getStore('courses')
			.addIndex('words', 'words', { multiEntry: true })
	.version(3)
		.getStore('courses')
			.addIndex('profWords', 'profWords', { multiEntry: true })
	.version(4)
		.getStore('courses')
			.delIndex('profs')
			.addIndex('instructors', 'instructors', { multiEntry: true })
			.delIndex('places')
			.addIndex('locations', 'locations', { multiEntry: true })
			.delIndex('sect')
			.addIndex('section', 'section')
			.delIndex('sem')
			.addIndex('semester', 'semester')
			.delIndex('halfcredit')
	.version(5)
		.addStore('courseCache', { key: 'id' })
		.addStore('areaCache', { key: 'id' })
		.getStore('areas')
			.delIndex('sourcePath')
		.getStore('courses')
			.delIndex('desc')
			.delIndex('notes')
			.delIndex('title')
			.delIndex('name')
	.version(6)
		.getStore('courses')
			.delIndex('depts')
			.addIndex('departments', 'departments', { multiEntry: true })
			.delIndex('num')
			.addIndex('number', 'number', { multiEntry: true })
	.version(7)
		.getStore('courses')
			.delIndex('times')
			.delIndex('locations')
			.delIndex('departments')
			.addIndex('department', 'department')
